/**
 * OpenAI-only Responses API output formats for the PowerPoint agent.
 *
 * GPT enforces the terminal reply shape through strict structured output.
 * Claude cannot use structured outputs on our Vertex project, so it follows
 * the same shape from the system prompt and its session parses leniently;
 * changing `OPENAI_TERMINAL_CHAT_JSON_SCHEMA` needs that parser to follow.
 */

import type { ToolExecutionPolicy } from "./types";
import { OPENAI_MODIFICATION_JSON_SCHEMA, type JsonSchema } from "./agentToolSchemas";

export const OPENAI_MODIFICATION_RESPONSE_FORMAT: JsonSchema = {
  type: "json_schema",
  name: "presentation_modification_v1",
  schema: OPENAI_MODIFICATION_JSON_SCHEMA,
  strict: false,
};

export const OPENAI_TERMINAL_CHAT_JSON_SCHEMA: JsonSchema = {
  type: "object",
  additionalProperties: false,
  required: ["mode", "reply"],
  properties: {
    mode: {
      type: "string",
      enum: ["chat"],
      description:
        "Terminal output in agentic mode is chat-only. All PowerPoint edits must be performed through apply_edits before the final response.",
    },
    reply: {
      type: "string",
      description:
        "Final user-facing summary after any tool-based work. Plain prose, 1-3 sentences, no JSON and no markdown headings.",
    },
  },
};

export const OPENAI_TERMINAL_CHAT_RESPONSE_FORMAT: JsonSchema = {
  type: "json_schema",
  name: "terminal_chat_v1",
  schema: OPENAI_TERMINAL_CHAT_JSON_SCHEMA,
  strict: true,
};

export function buildOpenAIModificationResponseFormat(
  _toolPolicy?: ToolExecutionPolicy
): JsonSchema {
  return OPENAI_TERMINAL_CHAT_RESPONSE_FORMAT;
}
